module.exports = __webpack_public_path__ + "static/img/5.ca77163.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/img/5.png
// module id = yi0f
// module chunks = 10